import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';
import { Link, env } from "../../../functional/global-import";
import { analytics } from '../../../functional/segments';

const BreadCrumb = (props) => {
    const [activeItem, setActiveItem] = useState()
    const isTeacherLogin = useSelector(state => state.auth.userDetail.isTeacher);


    useEffect(() => {
        if (props?.isActive) {
            setActiveItem(props?.isActive)
        }
    });

    return (
        <>
            <List.Item name="Library" active={activeItem === 'Library'} as={Link} to={`${env.PUBLIC_URL}/teacher-library`}
            >ALEE Library</List.Item>
            {isTeacherLogin &&
                <>
                    <List.Item 
                        name="Mylibrary" 
                        active={activeItem === 'Mylibrary'} 
                        as={Link} 
                        to={`${env.PUBLIC_URL}/my-library`}
                        onClick={() => { analytics.track(`ALEE - Click “My Library”`); }}
                    >My Library</List.Item>
                    <List.Item 
                        name="curatedForYou" 
                        active={activeItem === 'curatedForYou'} 
                        as={Link} 
                        to={`${env.PUBLIC_URL}/curatedForYou`}
                        onClick={() => { analytics.track(`ALEE - Click “Curated For You”`); }}
                    >Curated For you</List.Item>
                </>
            }
        </>
    );
}
export default BreadCrumb;